console.log("menu-hover loaded");

document.addEventListener("mouseover", (e) => {
  const item = e.target.closest(".menu-item[data-image]");
  if (!item) return;

  const tab = item.closest(".menu-tab-content") || document;
  let preview = tab.querySelector(".menu-hover-preview");

  if (!preview) {
    preview = document.createElement("div");
    preview.className = "menu-hover-preview";
    preview.innerHTML = `<img alt="" loading="lazy">`;
    tab.appendChild(preview);
  }

  const img = preview.querySelector("img");
  img.src = item.getAttribute("data-image");
  img.alt = item.querySelector("strong")?.textContent?.trim() || "";

  preview.classList.add("is-visible");

  const items = Array.from(tab.querySelectorAll(".menu-item"));
  const index = items.indexOf(item);

  preview.classList.toggle("right", index % 2 === 0);
  preview.classList.toggle("left", index % 2 === 1);
});

document.addEventListener("mouseout", (e) => {
  const item = e.target.closest(".menu-item[data-image]");
  if (!item) return;

  const tab = item.closest(".menu-tab-content") || document;
  const preview = tab.querySelector(".menu-hover-preview");
  preview?.classList.remove("is-visible");
});
